import styled, { css } from 'styled-components';

export const Description = styled.div`
  cursor: pointer;
  font-size: 24px;
  line-height: 1.45;
  transition: color 0.5s ease-out;
  position: relative;
  padding-right: 104px;
  margin-bottom: 25px;
  color: ${(props) =>
    props.active ? props.theme.color.primary800 : props.theme.color.gray500};

  &:hover {
    color: ${(props) =>
      props.active ? props.theme.color.primary800 : props.theme.color.cta};
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    height: 2px;
    width: 0;
    background-color: ${(props) => props.theme.color.cta};
    transition: width 0.25s ease-out;
  }

  ${(props) =>
    props.active &&
    css`
      &:after {
        width: 54px;
      }
    `}
`;

export const Content = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  display: ${(props) => (props.active ? 'block' : 'none')};
  opacity: 0;
  transition: opacity 0.25s ease-out;

  ${(props) =>
    props.active &&
    css`
      animation: fadeIn;
      animation-duration: 1s;
      animation-delay: 0.25s;
      animation-fill-mode: forwards;
    `}
`;

export default { Description, Content };
